<template>
	<div
		class="person"
		:class="{'no-image': !image}"
		@mouseover="show = true"
		@mouseleave="show = false"
	>
		<img
			:src="image"
			:alt="full_name"
		/>
		<transition name='fade'>
			<div
				class='content'
				v-if='show'
			>
				<h4
					v-if="full_name"
					v-html="full_name + ' -'"
					data-aos="fade-right"
					data-aos-delay="50"
				></h4>
				<h4
					v-if="position"
					class="position"
					v-html="position"
					data-aos="fade-right"
					data-aos-delay="100"
				></h4>
				<p
					v-if='bio'
					class="bio"
					v-html="bio"
					data-aos="fade-right"
					data-aos-delay="150"
				></p>
				<a
					v-if='linkedin'
					class="linkedin"
					:href="linkedin"
					target="_blank"
					data-aos="fade-right"
					data-aos-delay="200"
				><svg
						width="57"
						height="57"
						viewBox="0 0 57 57"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M55.04 28.02C55.04 42.938 42.9475 55.04 28.02 55.04C13.1021 55.04 1 42.9475 1 28.02C1 13.0923 13.0923 1 28.02 1C42.9475 1 55.04 13.1021 55.04 28.02ZM28.02 56.04C43.5 56.04 56.04 43.49 56.04 28.02C56.04 12.55 43.5 0 28.02 0C12.54 0 0 12.54 0 28.02C0 43.5 12.55 56.04 28.02 56.04ZM34.6 17.5098C36.77 17.5098 38.54 19.2698 38.54 21.4498V34.5998C38.54 36.7698 36.78 38.5398 34.6 38.5398H21.45C19.28 38.5398 17.51 36.7798 17.51 34.5998V21.4498C17.51 19.2798 19.27 17.5098 21.45 17.5098H34.6ZM32.13 30.0398V35.1198H35.28V29.6698C35.28 26.7598 33.72 25.3998 31.64 25.3998C29.9807 25.3998 29.2264 26.2954 28.81 26.952V25.6198H25.64C25.64 25.6198 25.68 26.5098 25.64 35.1198H28.81V29.8098C28.81 29.5298 28.83 29.2398 28.91 29.0398C29.14 28.4798 29.66 27.8898 30.54 27.8898C31.68 27.8898 32.13 28.7498 32.13 30.0398ZM28.81 26.952C28.7998 26.968 28.7898 26.984 28.78 26.9998H28.81V26.952ZM22.32 24.3198C23.44 24.3198 24.12 23.5798 24.12 22.6798H24.13C24.11 21.7498 23.45 21.0398 22.36 21.0398C21.27 21.0398 20.56 21.7798 20.56 22.6798C20.56 23.5798 21.24 24.3198 22.31 24.3198H22.32ZM23.93 25.6098H20.76V35.1198H23.93V25.6098Z"
							fill="white"
						/>
					</svg>
				</a>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		image: {},
		full_name: {},
		position: {},
		bio: {},
		excerpt: {},
		phone: {},
		email: {},
		linkedin: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.person {
	display: flex;
	align-items: flex-start;
	gap: 24px;
	grid-column: span 3;
	border-top: 1px solid var(--bright-blue);
	position: relative;
	overflow: hidden;

	@media (max-width: $mobile-xl) {
		grid-column: span 2;
	}

	@media (max-width: $mobile) {
		grid-column: span 4;
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		position: absolute;
		top: 0;
		left: 0;
		width: calc(100% - 100px);
		height: calc(100% - 100px);
		gap: 8px;
		z-index: 10;
		background: var(--duco-blue);
		border-radius: 30px;
		padding: 50px 50px;
		overflow: hidden;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}

		h4,
		h5 {
			margin: 0 0 0;
			/* font: normal normal normal 22px/32px var(--primary-font-family); */
			color: var(--white);
			text-transform: capitalize;
		}

		p {
			margin: 0;

			&.position {
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--white);
			}

			&.bio {
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--white);
				margin: 0 0 32px;
				opacity: 0.7;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}
		}

		a {
			height: auto;
			margin-bottom: 16px;

			@media (max-width: $mobile-xl) {
				margin-bottom: 8px;
			}

			&:last-of-type {
				margin-bottom: 0;
			}

			&.phone {
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--white);
			}

			&.email {
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--white);
			}

			&.linkedin {
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--white);
			}

			position: relative;
			padding-left: 16px;
			text-decoration: underline;
			display: flex;
			font: normal normal normal 16px/24px var(--primary-font-family);
			color: var(--white);
			align-items: center;

			&:hover {
				text-decoration: underline;
			}

			&[href^='mailto:'] {
				padding-left: 32px;

				&::before {
					width: 32px;
					height: auto;
					border-radius: none;
					background: none;
					display: block;
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS45OTkiIGhlaWdodD0iMTAuOCIgdmlld0JveD0iMCAwIDE1Ljk5OSAxMC44Ij4KICA8cGF0aCBpZD0iSWNvbl96b2NpYWwtZW1haWwiIGRhdGEtbmFtZT0iSWNvbiB6b2NpYWwtZW1haWwiIGQ9Ik0uMDcyLDEzLjkxMVY1LjAyNXEwLS4wMTUuMDQ2LS4yOTNsNS4yMyw0LjQ3NEwuMTM0LDE0LjIyYTEuMzA4LDEuMzA4LDAsMCwxLS4wNjItLjMwOVptLjY5NC05LjhhLjY2NS42NjUsMCwwLDEsLjI2Mi0uMDQ2SDE1LjExNWEuODc0Ljg3NCwwLDAsMSwuMjc4LjA0NkwxMC4xNDcsOC42bC0uNjk0LjU1NUw4LjA3OSwxMC4yODYsNi43MDYsOS4xNTksNi4wMTIsOC42Wk0uNzgyLDE0LjgyMiw2LjA0Myw5Ljc3N2wyLjAzNywxLjY1MSwyLjAzNy0xLjY1MSw1LjI2MSw1LjA0NWEuNzQxLjc0MSwwLDAsMS0uMjYyLjA0NkgxLjAyOWEuNy43LDAsMCwxLS4yNDctLjA0NlpNMTAuODEsOS4yMDZsNS4yMTUtNC40NzRhLjkyMS45MjEsMCwwLDEsLjA0Ni4yOTN2OC44ODdhMS4xODIsMS4xODIsMCwwLDEtLjA0Ni4zMDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wNzIgLTQuMDY4KSIgZmlsbD0iIzAwMzc2NCIvPgo8L3N2Zz4K');
					position: absolute;
					left: 0;
					margin-right: 10px;
				}
			}

			&[href^='tel:'] {
				padding-left: 32px;

				&::before {
					width: 32px;
					height: auto;
					border-radius: none;
					background: none;
					display: block;
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4wMDEiIGhlaWdodD0iMTUuOTk1IiB2aWV3Qm94PSIwIDAgMTYuMDAxIDE1Ljk5NSI+CiAgPHBhdGggaWQ9IkNhbGwtaWNvbiIgZD0iTTIwLjAyOSwxNy4wMjdhMTMuNDQsMTMuNDQsMCwwLDAtMi44MDgtMS44NzhjLS44NDEtLjQtMS4xNS0uNC0xLjc0NS4wMzMtLjUuMzU4LS44MTYuNjkxLTEuMzg3LjU2NkE4LjI3NSw4LjI3NSwwLDAsMSwxMS4zLDEzLjY4Nyw4LjIxMyw4LjIxMywwLDAsMSw5LjI0LDEwLjljLS4xMjEtLjU3NS4yMTItLjg5MS41NjctMS4zODcuNDI5LS42LjQ0Mi0uOS4wMzMtMS43NDVBMTMuMTcsMTMuMTcsMCwwLDAsNy45NjIsNC45NjNjLS42MTItLjYxMi0uNzUtLjQ3OS0xLjA4Ny0uMzU4YTYuMTg3LDYuMTg3LDAsMCwwLTEsLjUyOUEzLDMsMCwwLDAsNC42ODMsNi40Yy0uMjM3LjUxMi0uNTEyLDEuNDY2Ljg4NywzLjk1NmEyMi4wNzUsMjIuMDc1LDAsMCwwLDMuODgyLDUuMTc2aDBsMCwwLDAsMGgwYTIyLjE2NiwyMi4xNjYsMCwwLDAsNS4xNzgsMy44ODFjMi40OTEsMS40LDMuNDQ1LDEuMTI0LDMuOTU3Ljg4N2EyLjk1MiwyLjk1MiwwLDAsMCwxLjI2Mi0xLjIsNi4xODQsNi4xODQsMCwwLDAsLjUyOS0xQzIwLjUwOCwxNy43NzYsMjAuNjQ2LDE3LjYzOSwyMC4wMjksMTcuMDI3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuNDkgLTQuNTAyKSIgZmlsbD0iIzAwMzc2NCIvPgo8L3N2Zz4K');
					position: absolute;
					left: 0;
					margin-right: 10px;
				}
			}

			&.linkedin {
				padding-left: 0;

				/* &::before {
					width: 32px;
					height: auto;
					border-radius: none;
					background: none;
					display: block;
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iSWNvbl9hd2Vzb21lLWxpbmtlZGluLWluIiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1saW5rZWRpbi1pbiIgZD0iTTMuNTgxLDE2SC4yNjRWNS4zMThIMy41ODFaTTEuOTIxLDMuODYxQTEuOTMsMS45MywwLDEsMSwzLjg0MiwxLjkyMiwxLjkzNywxLjkzNywwLDAsMSwxLjkyMSwzLjg2MVpNMTYsMTZoLTMuMzFWMTAuOGMwLTEuMjM5LS4wMjUtMi44MjktMS43MjUtMi44MjktMS43MjUsMC0xLjk4OSwxLjM0Ni0xLjk4OSwyLjczOVYxNkg1LjY1OVY1LjMxOEg4Ljg0MVY2Ljc3NWguMDQ2QTMuNDg2LDMuNDg2LDAsMCwxLDEyLjAyNiw1LjA1QzE1LjM4Myw1LjA1LDE2LDcuMjYxLDE2LDEwLjEzMlYxNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTAuMDAxKSIgZmlsbD0iIzAwMzc2NCIvPgo8L3N2Zz4K');
					position: absolute;
					left: 0;
					margin-right: 10px;
				} */
			}
		}
	}
}

/* .fade-enter-active,
.fade-leave-active {
	transition: all 0.2s;
	transform: translateX(0);
}
.fade-enter-from, .fade-leave-to {
	opacity: 0;
	transform: translateX(-100%);
} */

.fade-enter-active {
	animation: fade-in 0.3s;
}
.fade-leave-active {
	animation: fade-in 0.3s reverse;
}
@keyframes fade-in {
	0% {
		opacity: 0;
		transform: translateX(-100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PersonTile.vue